import { createApp } from 'vue';
import CampaignCtaButtonBlock from './campaignCtaButtonBlock.vue';
import store from 'shared/store';

const campaignCtaButtonBlocks = document.querySelectorAll(
	"[data-feature='campaignCtaButtonBlock']"
);

if (campaignCtaButtonBlocks.length) {
	campaignCtaButtonBlocks.forEach((campaignCtaButtonBlock) => {
		const app = createApp({
			name: 'CampaignCtaButtonBlockApp',
		});
		app.component('campaign-cta-button-block', CampaignCtaButtonBlock);
		app.use(store);
		app.mount(campaignCtaButtonBlock);
	});
}
